export * from './subscriptions.service';
import { SubscriptionsService } from './subscriptions.service';
export const APIS = [SubscriptionsService];
